import {ColonistCoinProduct} from '../../../../shared/store/ColonistCoinProduct'
import {createDivIn, createImgIn, createHeaderIn, createLinkIn, createParagraphIn, setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils'
import {doActionIfLoggedIn} from '../../../shared/scripts/store/StoreUtils'
import {CA} from '../../../shared/scripts/analytics/Analytics'
import {UIAPIEndpoints} from '../../../shared/scripts/network/UIAPIEndpoints'
import {TranslationObject} from '@colonist/i18n'
import {navigateToPage} from '../ui_utils/ClientUtils.ts'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables.ts'
import {AudioManager, AudioType} from '@colonist/audio'

export class UICoinProductView {
    protected readonly product: ColonistCoinProduct
    private readonly productUrl: string

    constructor(container: HTMLDivElement, product: ColonistCoinProduct, onClickEvent?: () => void, localizedPrice?: string) {
        this.product = product

        const productDiv = createDivIn(container, 'store_page_coin_product', '')

        const headerDiv = createDivIn(productDiv, 'store_page_coin_product_header')
        const coinsTotalText: TranslationObject = {key: 'strings:storePage.coins.title', options: {count: product.baseCoinAmount + product.bonusCoinAmount}}
        const coinsTotal = createHeaderIn(headerDiv, coinsTotalText, '', '', 'H2')

        if(product.bonusCoinAmount != 0) {
            const coinAmount = createParagraphIn(headerDiv, {key: 'strings:colonistCommon.utils.#buffer', options: {value: product.baseCoinAmount + ' '}}, '')
            const bonusAmount = createParagraphIn(coinAmount, {key: 'strings:storePage.coins.bonusAmount', options: {count: product.bonusCoinAmount}}, 'store_page_coin_product_bonus')
        }

        const bodyDiv = createDivIn(productDiv, 'store_page_coin_product_body', '')
        const img = createImgIn(bodyDiv, product.lobbyImage)

        this.productUrl = UIAPIEndpoints.checkoutProductUrl(product.type)
        const priceText: TranslationObject = {key: 'strings:colonistCommon.utils.#buffer', options: {value: localizedPrice ?? product.getUSDPriceWithSign()}}
        const buyButton = createLinkIn(productDiv, '#', priceText, 'store_button btn_general')
        setElementOnClick(buyButton, () => this.handleBuyButtonClicked(onClickEvent))

        if(product.bannerText != undefined) {
            const bannerDiv = createDivIn(productDiv, 'store-page-product-banner')
            const banner = createParagraphIn(bannerDiv, product.bannerText, '')
        }
    }

    protected handleBuyButtonClicked(onClickEvent?: () => void) {
        AudioManager.play(AudioType.Click)
        CA.sendGoogleAnalyticsEvent(CA.Category.Store, CA.Label.StoreClickedPurchaseCoin, this.product.price)

        if(onClickEvent) onClickEvent()

        doActionIfLoggedIn(() => {
            if(UIUtilsEjsVariables.isUserOnMobileAppOrWeb) return
            navigateToPage(this.productUrl)
        })
    }
}
